export default "__VITE_ASSET__Cu3yM1yY__"